import { PAGE_TRACKING } from "~/tools/getTrackingCategoryName";

export const TRACKING_DATA = {
  onClickBanner: {
    category: PAGE_TRACKING.FLIGHTS_SUMMARY,
    action: "bottom-bar",
    label: "bottom-bar_click:info_pag:summary",
  },
};
